<template>
  <div>
    <!-- Logged-in menu -->
    <div v-if="isLoggedin && isNotInRegisterationPage" style="background: white">
      <!-- Nav items -->
      <div
        v-for="nav in filteredLoggedInNavBarMenu"
        :key="nav.title"
        class="mobile-nav-item d-flex align-center"
        style="
          height: 57px;
          padding: 0 24px;
          border-bottom: 1px solid #d0d0d0;
          font-size: 18px;
          font-family: Arial, sans-serif;
          cursor: pointer;
          position: relative;
        "
        @click="handleNavClick(nav)"
      >
        <RouterLink
          v-if="nav.route"
          :to="nav.route"
          style="text-decoration: none; color: #191919; width: 100%; height: 100%; display: flex; align-items: center"
        >
          {{ nav.title }}
        </RouterLink>
        <a
          v-else-if="nav.href"
          :href="nav.href"
          target="_blank"
          style="text-decoration: none; color: #191919; width: 100%; height: 100%; display: flex; align-items: center"
        >
          {{ nav.title }}
        </a>
        <!-- Active indicator - gold bar (width matches nav text) -->
        <div
          v-if="nav.route && isActiveRoute(nav.route)"
          :style="{
            position: 'absolute',
            bottom: 0,
            left: '24px',
            height: '8px',
            background: '#ffc627',
            borderRadius: '2px 2px 0 0',
            width: nav.title.length + 'ch'
          }"
        />
      </div>

      <!-- Logout item -->
      <div
        class="d-flex align-center"
        style="
          height: 57px;
          padding: 0 24px;
          border-bottom: 1px solid #d0d0d0;
          font-size: 18px;
          font-family: Arial, sans-serif;
          cursor: pointer;
        "
        @click="handleLogout"
      >
        <span style="color: #191919">Logout</span>
      </div>

      <!-- Search section -->
      <div
        class="d-flex align-center"
        style="height: 72px; padding: 0 24px; background: #fafafa; border-bottom: 1px solid #d0d0d0"
      >
        <div
          class="d-flex align-center w-100"
          style="background: #fff; border: 1px solid #d0d0d0; border-radius: 4px; height: 44px; padding: 0 12px"
        >
          <v-icon size="20" style="color: #747474; margin-right: 8px">mdi-magnify</v-icon>
          <input
            role="search"
            type="search"
            placeholder="Search ASU"
            v-model="mobileSearchText"
            @keyup.enter="searchAsu"
            style="
              border: none;
              outline: none;
              width: 100%;
              font-size: 16px;
              font-family: Arial, sans-serif;
              background: transparent;
            "
          />
        </div>
      </div>

      <!-- Footer links -->
      <a
        href="https://asu.edu"
        target="_blank"
        class="d-flex align-center justify-center"
        style="
          height: 72px;
          background: #fafafa;
          border-bottom: 1px solid #d0d0d0;
          font-size: 18px;
          font-family: Arial, sans-serif;
          text-decoration: none;
          color: #191919;
        "
        @click="asuoDataLayerClick('appHeader', '0')"
      >
        ASU Home
      </a>
      <a
        href="https://my.asu.edu"
        target="_blank"
        class="d-flex align-center justify-center"
        style="
          height: 72px;
          background: #fafafa;
          border-bottom: 1px solid #d0d0d0;
          font-size: 18px;
          font-family: Arial, sans-serif;
          text-decoration: none;
          color: #191919;
        "
        @click="asuoDataLayerClick('appHeader', '1')"
      >
        My ASU
      </a>
      <a
        href="https://asu.edu/about/colleges-and-schools/"
        target="_blank"
        class="d-flex align-center justify-center"
        style="
          height: 72px;
          background: #fafafa;
          border-bottom: 1px solid #d0d0d0;
          font-size: 18px;
          font-family: Arial, sans-serif;
          text-decoration: none;
          color: #191919;
        "
        @click="asuoDataLayerClick('appHeader', '2')"
      >
        Colleges and Schools
      </a>
    </div>

    <!-- Logged-out menu (kept largely as-is) -->
    <v-container class="px-0 py-0" style="background: white" v-if="!isLoggedin && !isNotInRegisterationPage">
      <v-list>
        <template v-for="(nav, index) in loggedOutNavBarMenu" :key="index">
          <v-list-group v-if="hasChildren(nav)">
            <template #activator="{ props }">
              <v-list-item v-bind="props" class="pl-3 py-3">
                <v-list-item-title>
                  <span
                    style="font-size: 18px; line-height: 1.4; font-weight: normal; position: relative"
                    class="group-list"
                  >
                    {{ nav.htmlLink.text }}
                  </span>
                </v-list-item-title>
              </v-list-item>
            </template>
            <v-list>
              <v-list-item
                v-for="(item, i) in nav.children"
                :key="i"
                style="border-bottom: 1px solid #e8e8e8"
                class="py-1"
                @click="asuoDataLayerClick('LoggedOutSecondaryheader', '0', '')"
              >
                <v-list-item-title>
                  <a style="color: black" :href="item.htmlLink.uri" :target="item.htmlLink.target">{{
                    item.htmlLink.text
                  }}</a>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-list-group>
          <v-list-item v-else @click="asuoDataLayerClick('LoggedOutSecondaryheader', '0')">
            <v-list-item-title>
              <a style="font-size: 18px; line-height: 1.4" :href="nav.htmlLink.uri" :target="nav.htmlLink.target">{{
                nav.htmlLink.text
              }}</a>
            </v-list-item-title>
          </v-list-item>
        </template>
        <v-list-item class="py-3">
          <template #append>
            <div>
              <v-btn
                variant="flat"
                color="#8c1d40"
                style="border-radius: 25px"
                @click="asuoDataLayerClick('SecondaryHeaderComponent', '5', '')"
              >
                <span @click="login" style="color: #fff; font-weight: bold">Login</span>
              </v-btn>
              <v-btn
                v-if="isEligibleForSignUp"
                variant="flat"
                color="#f9c500"
                style="border-radius: 25px"
                @click="register"
              >
                <span style="font-weight: bold">Register</span>
              </v-btn>
            </div>
          </template>
        </v-list-item>
      </v-list>
    </v-container>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { useUserStore } from '@/stores/user';

import { DataLayerMixin } from '../mixins/dataLayerMixin.js';

export default defineComponent({
  emits: ['doLogOut', 'close'],
  name: 'MobileNavBar',

  data() {
    return {
      mobileSearchText: ''
    };
  },

  mixins: [DataLayerMixin],

  props: {
    loggedInNavBarMenu: Array,
    loggedOutNavBarMenu: Array,
    mobileHeader: Boolean,
    isLoggedin: Boolean,
    isNotInRegisterationPage: Boolean,
    isPathwaysAllowed: Boolean
  },

  methods: {
    async doLogOut() {
      await this.$emit('doLogOut');
    },
    hasChildren(item) {
      return item.children && item.children.length > 0;
    },
    register() {
      this.$router.push({ name: 'Registerv2' });
    },
    login() {
      this.$auth.login('asurite');
    },
    isActiveRoute(route) {
      return this.$route.path === route;
    },
    handleNavClick(nav) {
      this.asuoDataLayerClick('SecondaryHeaderComponent', nav.dataLayerIndex, '');
      // Auto-close the menu after navigation
      this.$nextTick(() => {
        this.$emit('close');
      });
    },
    handleLogout() {
      this.asuoDataLayerClick('SecondaryHeaderComponent', '5', '');
      this.doLogOut();
      this.$emit('close');
    },
    searchAsu() {
      if (this.mobileSearchText) {
        window.open(`https://search.asu.edu/?q=${this.mobileSearchText}`, '_blank');
      }
    }
  },

  computed: {
    filteredLoggedInNavBarMenu() {
      return this.isPathwaysAllowed
        ? this.loggedInNavBarMenu
        : this.loggedInNavBarMenu.filter((menu) => menu.title != 'Pathways');
    },
    isEligibleForSignUp() {
      const userStore = useUserStore();
      return userStore.welcomePageData.isEligibleForSignUp || false;
    }
  }
});
</script>

<style scoped>
.v-list {
  padding: 0px;
}
</style>

<style lang="scss" scoped>
.v-list__group {
  .v-list__group__header--active {
    border-top: 2px solid black !important;
    border-bottom: 2px solid black !important;
  }
  .v-list__group__header--active > .v-list__tile__content > .group-list::after {
    content: '';
    display: block;
    height: 0.5rem;
    background-color: #ffc627;
    width: 100%;
    position: absolute;
    bottom: -16px;
  }

  .v-list__group__header {
    background-color: white !important;
  }
  .v-list__group__header__append-icon > i.v-icon {
    color: black;
  }
}
</style>
